export function JobListItemSkeleton() {
  return (
    <div className="px-4 py-3 flex items-center gap-4 border-t border-black/15">
      <div className="hidden lg:flex w-16 h-16 shrink-0 rounded-lg bg-gray-200 animate-pulse" />
      <div className="flex justify-between flex-1 gap-4">
        <div className="flex flex-col gap-3 flex-1">
          <div className="flex flex-col gap-1">
            <div className="h-4 w-3/4 rounded bg-gray-200 animate-pulse" />
            <div className="h-3 w-1/3 rounded bg-gray-200 animate-pulse" />
          </div>
          <div className="h-4 w-24 rounded bg-gray-200 animate-pulse" />
        </div>
        <div className="flex flex-col items-end gap-2 shrink-0">
          <div className="h-4 w-4 rounded bg-gray-200 animate-pulse" />
          <div className="h-2.5 w-20 rounded bg-gray-200 animate-pulse" />
          <div className="h-2.5 w-16 rounded bg-gray-200 animate-pulse" />
        </div>
      </div>
    </div>
  );
}

export function JobListSkeleton({ count = 6 }: { count?: number }) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <JobListItemSkeleton key={index} />
      ))}
    </>
  );
}
